import { Section } from '@rumblefish/ui/Rumblefish23Theme';
import React from 'react';

import cpuIcon from '../../../public/svg/icons/cpu.svg';
import eyeIcon from '../../../public/svg/icons/eye.svg';
import groupIcon from '../../../public/svg/icons/group.svg';
import horseIcon from '../../../public/svg/icons/horse.svg';
import oneIcon from '../../../public/svg/icons/one.svg';
import presentationIcon from '../../../public/svg/icons/presentation.svg';
import threeIcon from '../../../public/svg/icons/three.svg';
import timeIcon from '../../../public/svg/icons/time.svg';
import twoIcon from '../../../public/svg/icons/two.svg';
import {
  StyledImg,
  StyledLink,
  StyledTitle,
  StyledButton,
  StyledButtonWrapper,
  StyledLetsDiscussMobile,
} from '../LetsDiscuss/styles';
import type { HeroProps } from './FundraisingServices.types';
import {
  StyledStep,
  StyledStack,
  StyledSteps,
  StyledServices,
  StyledStepTitle,
  StyledTwoTitles,
  StyledFirstTitle,
  StyledSecondTitle,
  StyledServiceItem,
  StyledSeriviceIcon,
  StyledServiceTitle,
  StyledServiceDescription,
} from './styles';

export const FundraisingServices = ({ ...props }: HeroProps) => {
  return (
    <Section width="small">
      <StyledStack {...props}>
        <StyledTwoTitles>
          <StyledFirstTitle>
            Work with experienced partners to get the funding for your product
          </StyledFirstTitle>
          <StyledSecondTitle>
            Fundraising is the key responsibility of every startup founder. With
            our startup's fundraising consulting services budget will never be a
            problem again.
          </StyledSecondTitle>
        </StyledTwoTitles>
        <StyledServices>
          <StyledServiceItem>
            <div>
              <StyledSeriviceIcon>
                <img src={eyeIcon} alt="UX research" />
              </StyledSeriviceIcon>
            </div>
            <div>
              <StyledServiceTitle>UX Research</StyledServiceTitle>
              <StyledServiceDescription>
                Get to know your target audience! With our UX research, you’ll
                find out how to address the needs of your customers and make
                them fall in love with your product.
              </StyledServiceDescription>
            </div>
          </StyledServiceItem>
          <StyledServiceItem>
            <div>
              <StyledSeriviceIcon>
                <img src={groupIcon} alt="Startup discovery" />
              </StyledSeriviceIcon>
            </div>
            <div>
              <StyledServiceTitle>
                Startup Discovery Workshop
              </StyledServiceTitle>
              <StyledServiceDescription>
                The best products on the market start with a discovery workshop.
                This exercise will give you confidence that your startup fits
                the market needs as we analyze market conditions, potential
                competition, and define your startup’s objectives and target
                group.
              </StyledServiceDescription>
            </div>
          </StyledServiceItem>
          <StyledServiceItem>
            <div>
              <StyledSeriviceIcon>
                <img src={cpuIcon} alt="Tech stack advice" />
              </StyledSeriviceIcon>
            </div>
            <div>
              <StyledServiceTitle>
                Tech Stack Advisory For Your Startup
              </StyledServiceTitle>
              <StyledServiceDescription>
                Our experts will help you choose a battle-tested, reliable, and
                secure tech stack for your project. With our help, your startup
                will be efficient and scalable. It’s all about technology!
              </StyledServiceDescription>
            </div>
          </StyledServiceItem>
          <StyledServiceItem>
            <div>
              <StyledSeriviceIcon>
                <img src={horseIcon} alt="Product strategy consulting" />
              </StyledSeriviceIcon>
            </div>
            <div>
              <StyledServiceTitle>
                Product Strategy Consulting
              </StyledServiceTitle>
              <StyledServiceDescription>
                Take advantage of our experience in helping various startups
                take off. We will work closely with you and your team to help
                you polish your startup product strategy and build a reasonable,
                yet ambitious product roadmap.
              </StyledServiceDescription>
            </div>
          </StyledServiceItem>
          <StyledServiceItem>
            <div>
              <StyledSeriviceIcon>
                <img src={timeIcon} alt="Budget consulting" />
              </StyledSeriviceIcon>
            </div>
            <div>
              <StyledServiceTitle>
                Timeline & Budget Consulting
              </StyledServiceTitle>
              <StyledServiceDescription>
                We help startups build a timeline and budgeting plan to ensure
                maximum efficiency and eliminate waste of funds and resources.
              </StyledServiceDescription>
            </div>
          </StyledServiceItem>
          <StyledServiceItem>
            <div>
              <StyledSeriviceIcon>
                <img src={presentationIcon} alt="Pitch deck consulting" />
              </StyledSeriviceIcon>
            </div>
            <div>
              <StyledServiceTitle>
                Expert Pitch Deck Consulting
              </StyledServiceTitle>
              <StyledServiceDescription>
                Let’s create a winning pitch deck that sets you apart from the
                competition. Our team has experience working with startups
                across various industries, and we'll use that expertise to help
                you craft a pitch deck that resonates with potential investors.
                Our design & development teams will make sure your presentation
                is professional and visually appealing, setting the stage for a
                successful pitch.
              </StyledServiceDescription>
            </div>
          </StyledServiceItem>
        </StyledServices>

        <StyledLetsDiscussMobile>
          <StyledImg />
          <StyledTitle>
            Let's discuss <br />
            the details of your project!
          </StyledTitle>
          <StyledButtonWrapper>
            <StyledLink to="/contact">
              <StyledButton>Book a free consultation</StyledButton>
            </StyledLink>
          </StyledButtonWrapper>
        </StyledLetsDiscussMobile>

        <StyledSteps>
          <StyledStep>
            <StyledSeriviceIcon>
              <img src={oneIcon} alt="Get advice at any stage" />
            </StyledSeriviceIcon>
            <StyledStepTitle>
              Get advice at any stage of the process
            </StyledStepTitle>
            <StyledServiceDescription>
              Let’s face it - building a company is not a piece of cake. Every
              founder needs to face tasks that might feel impossible. Instead of
              getting stuck and trying to reinvent the wheel, get help from
              those who have been there before. Our startup consulting team will
              help you overcome pain points at any stage of your process.
            </StyledServiceDescription>
          </StyledStep>
          <StyledStep>
            <StyledSeriviceIcon>
              <img src={twoIcon} alt="Product concept step" />
            </StyledSeriviceIcon>
            <StyledStepTitle>
              You bring your product concept. We turn it into reality!
            </StyledStepTitle>
            <StyledServiceDescription>
              Our software development teams consist of seasoned professionals
              that work tirelessly to make your product a technological piece of
              art. We pride ourselves on continuous training, learning new
              skills and tools to always offer the most current and efficient
              solutions for your startup.
            </StyledServiceDescription>
          </StyledStep>
          <StyledStep>
            <StyledSeriviceIcon>
              <img src={threeIcon} alt="Grow your business" />
            </StyledSeriviceIcon>
            <StyledStepTitle>
              Grow your business with Rumble Fish
            </StyledStepTitle>
            <StyledServiceDescription>
              Making your startup scalable is not an easy task. Almost every
              founder struggles with it at some point. With our business
              consulting experience mixed with tech savviness, you’ll have a
              complete set of tools and help to get you there!
            </StyledServiceDescription>
          </StyledStep>
        </StyledSteps>
      </StyledStack>
    </Section>
  );
};
